import React from "react";

const Header = () => {
	return (
		<div>
			<div className="title">
				<h1>Violaine Ernotte</h1>
				<h2>Développeuse Web Front</h2>
			</div>
		</div>
	);
};

export default Header;
